module.exports = __webpack_public_path__ + "static/media/3.388afeb7.jpg";